import { Role } from './role';

export class User {
  id: string;
  email: string;
  password: string;
  fullName: string;
  role: Role;
  token?: string;
}

export class UserResponse {
  _id: string;
  email: string;
  nombreCompleto: string;
  rol: Role;
}

export class AuthHeaders {
  iduser: string;
  key: string;
}

export class UserInfo {
  _id: string;
  nombreCompleto: string;
  email: string;
  rol: Role;
  centros: String[];
  estado: boolean;
}

export class AccessFile {
  _idAccount: string;
  password: string;
}

export class NewAccountProperties {
  role: Role;
  force: 'true' | 'false';
  email: string;
  displayName: string;
  center: string[];
}

export class Device {
  uid: string;
  password?: string;
}
